import type {StyleRef} from '@wix/document-services-types'

export const DROPDOWN_SKIN = 'wixui.skins.Dropdown'

export const megaMenuContainerItemInitialStyleItem = () =>
    ({
        type: 'ComponentStyle',
        skin: DROPDOWN_SKIN,
        styleType: 'custom',
        style: {
            properties: {},
            propertiesSource: {},
            groups: {}
        },
        componentClassName: 'wixui.MegaMenuContainerItem'
    } as StyleRef)
